module.exports = __webpack_public_path__ + "static/Galanogrotesque-Medium-51a91cb3c3406c8a1019285ca043a4e8.woff";